import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: "31c4b2c0-7d18-46e9-8ac3-ce8ea2328616",
    imgsrc: "/images/mango.webp",
    name: "Apple",
    categoryName: "Seasonal Fruit",
    price: "100",
    discountprice: "200",
    toggleImage: "/images/toggleimg1.jpeg",
    rating: 4,
  },
  {
    _id: "8ee9693e-fd01-43de-bb8a-e2814d39be14",
    imgsrc: "/images/anaar.webp",
    name: "Pomegranate",
    categoryName: "Regular Fruit",
    price: "200",
    discountprice: "400",
    toggleImage: "/images/toggleimg2.jpeg",
    rating: 4,
  },
  {
    _id: "a9225629-54a2-4862-8ed5-fd8e1c4abd09",
    imgsrc: "/images/green-apple.webp",
    name: "Green Apple",
    categoryName: "Regular Fruit",
    price: " 400",
    discountprice: "800",
    toggleImage: "/images/toggleimg3.jpg",
    rating: 5,
  },
  {
    _id: "b67e0301-e76e-47a7-a974-c4e0ea2c2f2f",
    imgsrc: "/images/raddish.webp",
    name: "Raddish",
    categoryName: "Regular Fruit",
    price: "700",
    discountprice: "1400",
    toggleImage: "/images/toggleimg4.jpg",
    rating: 4,
  },
  {
    _id: "be597893-5ba2-416a-a0a9-b814fc7615f6",
    imgsrc: "/images/orange.webp",
    name: "Orange",
    categoryName: "Regular Fruit",
    price: "900",
    discountprice: "1800",
    toggleImage: "/images/sprout.webp",
    rating: 4,
  },
  {
    _id: "35ddc8a0-b57b-49f9-bfa6-159ea49365c7",
    imgsrc: "/images/alphonsos.webp",
    name: "Alphonsos",
    categoryName: "Seasonal Fruit",
    price: "1000",
    discountprice: "2000",
    toggleImage: "/images/rambutan.webp",
    rating: 5,
  },
  {
    _id: "35f6642c-5740-4498-aac5-b8b115baa25e",
    imgsrc: "/images/sprout.webp",
    name: "Avocado",
    categoryName: "Regular Fruit",
    price: "1200",
    discountprice: "2400",
    toggleImage: "/images/mongosteen.webp",
    rating: 3,
  },
  {
    _id: "d84dedcb-eaa2-483c-a82b-4857a7f762aa",
    imgsrc: "/images/kiwi.webp",
    name: "Kiwi",
    categoryName: "Regular Fruit",
    price: "1000",
    discountprice: "2000",
    toggleImage: "/images/lychee.webp",
    rating: 4,
  },
  {
    _id: "964b2c90-b27b-46ac-92d7-5d997feb1af1",
    imgsrc: "/images/brown-grapes.webp",
    name: "Brown Grapes",
    categoryName: "Regular Fruit",
    price: "800",
    discountprice: "1600",
    toggleImage: "/images/berrey.jpg",
    rating: 4,
  },
  {
    _id: "6d2ec634-0110-45c7-8608-5fa0a1b9d773",
    imgsrc: "/images/donec-odio2.jpg",
    name: "Donec Odio",
    categoryName: "Seasonal Fruit",
    price: "1000",
    discountprice: "2000",
    toggleImage: "/images/product5.jpg",
    rating: 5,
  },
  {
    _id: "e703df18-fb8b-404b-8cdc-5a4147ce51c6",
    imgsrc: "/images/apple.webp",
    name: "Apple",
    categoryName: "Regular Fruit",
    price: "1500",
    discountprice: "3000",
    toggleImage: "/images/kiwi.webp",
    rating: 5,
  },
  {
    _id: "60318290-6fa0-4e3d-a6a0-c14144f49bea",
    imgsrc: "/images/banana.jpg",
    name: "Banana",
    categoryName: "Regular Fruit",
    price: "1600",
    discountprice: "3200",
    toggleImage: "/images/orange.webp",
    rating: 4,
  },
  {
    _id: "56724d91-72e2-4520-ad33-096a648afc2a",
    imgsrc: "/images/carrot.webp",
    name: "Carrot",
    categoryName: "Seasonal Fruit",
    price: "1700",
    discountprice: "3400",
    toggleImage: "/images/white-berrey.webp",
    rating: 5,
  },
  {
    _id: "008e5d91-108b-477a-b0ca-5b2139441cfc",
    imgsrc: "/images/berrey.jpg",
    name: "Berrey",
    categoryName: "Seasonal Fruit",
    price: "1800",
    discountprice: "3600",
    toggleImage: "/images/banana.jpg",
    rating: 3,
  },
  {
    _id: "998d662e-c3f8-4827-a8be-60b303df155c",
    imgsrc: "/images/green-grapes.webp",
    name: "Green Grapes",
    categoryName: "Regular Fruit",
    price: "1300",
    discountprice: "2600",
    toggleImage: "/images/pomelo.webp",
    rating: 5,
  },
  {
    _id: "20b6f2c9-0e47-4713-8b23-c17d592dffbe",
    imgsrc: "/images/rambutan.webp",
    name: "Rambutan",
    categoryName: "Seasonal Fruit",
    price: "1900",
    discountprice: "3800",
    toggleImage: "/images/gwava.webp",
    rating: 2,
  },
  {
    _id: "368853a3-ed32-4eb3-9ea8-6bcda535ca9b",
    imgsrc: "/images/gwava.webp",
    name: "Gwava",
    categoryName: "Regular Fruit",
    price: "2000",
    discountprice: "4000",
    toggleImage: "/images/raddish.webp",
    rating: 1,
  },
  {
    _id: "33f5999e-ddfb-4a67-827e-4f5b01d936d8",
    imgsrc: "/images/pomelo.webp",
    name: "Pomelo",
    categoryName: "Seasonal Fruit",
    price: "2000",
    discountprice: "4000",
    toggleImage: "/images/toggleimg1.jpeg",
    rating: 3,
  },
  {
    _id: "03ed75a4-71dd-4788-b694-49206d9a46e5",
    imgsrc: "/images/mongosteen.webp",
    name: "Mangosteen",
    categoryName: "Seasonal Fruit",
    price: "2000",
    discountprice: "400",
    toggleImage: "/images/product8.webp",
    rating: 5,
  },
  {
    _id: "0bac3258-204c-4f6a-84e0-00f899e5e3b2",
    imgsrc: "/images/lychee.webp",
    name: "Lychee",
    categoryName: "Regular Fruit",
    price: "1400",
    discountprice: "2800",
    toggleImage: "/images/apple.webp",
    rating: 1,
  },
  {
    _id: "e563e885-35e3-4839-85d1-1840350429e0",
    imgsrc: "/images/mango1.webp",
    name: "Mango",
    categoryName: "Seasonalr Fruit",
    price: "1700",
    discountprice: "3400",
    toggleImage: "/images/anaar.webp",
    rating: 2,
  },
];
